import { Link } from 'react-router-dom';

export const EseAnswer = ({ type, answer, streaming }) => {
  // Ensure docs is an array or fallback to an empty array
  const docs = Array.isArray(answer?.docs) ? answer.docs : [];
  const arr = Array.isArray(docs[0]) ? docs[0] : docs;

  return (
    <div>
      <div>
        {/* Display the answer text */}
        <div dangerouslySetInnerHTML={{ __html: answer?.text || '' }} />
        
        {/* Display documents if they exist */}
        {answer?.displayDocs && arr.length > 0 && arr.map((doc, index) => (
          <div key={index}>
            Document {index + 1}: 
            <Link 
              className="text-indigo-600 underline" 
              target="_blank" 
              to={doc.url}>
              {doc.Document}
            </Link>
          </div>
        ))}
        <br />
      </div>
    </div>
  );
};
